import { ExperimentCommonGroups, } from './types';
var RbExperiments = /** @class */ (function () {
    function RbExperiments(experiments) {
        this.experiments = experiments;
    }
    RbExperiments.prototype.getGroup = function (experiment) {
        var experiments = this.experiments;
        var experimentItem = experiments && experiments.find(function (ex) { return ex.experiment === experiment; });
        if (!experimentItem || !experimentItem.group) {
            return ExperimentCommonGroups.NoEnrolment;
        }
        return experimentItem.group;
    };
    RbExperiments.prototype.getVariant = function (experiment) {
        var variant = this.getGroup(experiment);
        if (variant === ExperimentCommonGroups.NoEnrolment ||
            variant === ExperimentCommonGroups.Control) {
            return null;
        }
        return variant;
    };
    RbExperiments.prototype.isVariant = function (experiment) {
        var variant = this.getVariant(experiment);
        if (!variant) {
            return false;
        }
        return true;
    };
    return RbExperiments;
}());
export { RbExperiments };
